import styled from 'styled-components';

export const NavbarWidgetStyled = styled.div`
  padding: 0 3rem;
  height: 77px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 2rem;
  .nav_collapse_btn {
    flex: none;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: ${({ theme }) => theme.COLORS.BLACK_1 || '#1a1a1a'};
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;
    &:hover {
      background: ${({ theme }) => theme.COLORS.GRAY_4};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }
  }
  .nav_user_infomation {
  }
`;
